import { createSlice } from "@reduxjs/toolkit";

const cityDepoSlice = createSlice({
  name: "city_depo",
  initialState: {
    city: null,
    depot: null,
  },
  reducers: {
    setCityAndDepo: (state, action) => {
      const { city, depot } = action.payload;
      state.city = city;
      state.depot = depot;
    },
  }
})

export const { setCityAndDepo } = cityDepoSlice.actions;
export const selectCityDepo = (state) => state.city_depo;

export default cityDepoSlice.reducer;
